<template>
  <g>
    <path
      d="M4 5.34305C4 4.71187 4.51167 4.2002 5.14286 4.2002H9.29081C9.58549 4.2002 9.86878 4.31402 10.0815 4.51791L11.1685 5.5595C11.3812 5.76339 11.6645 5.87721 11.9592 5.87721H18.8571C19.4883 5.87721 20 6.38889 20 7.02007V18.4859C20 19.1171 19.4883 19.6288 18.8571 19.6288H5.14286C4.51168 19.6288 4 19.1171 4 18.4859V5.34305Z"
      fill="white"
    />
    <path
      d="M4 5.34305C4 4.71187 4.51167 4.2002 5.14286 4.2002H9.29081C9.58549 4.2002 9.86878 4.31402 10.0815 4.51791L11.1685 5.5595C11.3812 5.76339 11.6645 5.87721 11.9592 5.87721H18.8571C19.4883 5.87721 20 6.38889 20 7.02007V18.4859C20 19.1171 19.4883 19.6288 18.8571 19.6288H5.14286C4.51168 19.6288 4 19.1171 4 18.4859V5.34305Z"
      fill="url(#paint0_linear_939_1101)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.14286 4.7002C4.78782 4.7002 4.5 4.98801 4.5 5.34305V18.4859C4.5 18.8409 4.78782 19.1288 5.14286 19.1288H18.8571C19.2122 19.1288 19.5 18.8409 19.5 18.4859V7.02007C19.5 6.66503 19.2122 6.37721 18.8571 6.37721H11.9592C11.5356 6.37721 11.1284 6.21359 10.8225 5.9205L9.73559 4.87891C9.61592 4.76422 9.45656 4.7002 9.29081 4.7002H5.14286ZM3.5 5.34305C3.5 4.43573 4.23553 3.7002 5.14286 3.7002H9.29081C9.71441 3.7002 10.1216 3.86382 10.4275 4.15691L11.5144 5.1985C11.6341 5.31319 11.7934 5.37721 11.9592 5.37721H18.8571C19.7645 5.37721 20.5 6.11274 20.5 7.02007V18.4859C20.5 19.3932 19.7645 20.1288 18.8571 20.1288H5.14286C4.23553 20.1288 3.5 19.3932 3.5 18.4859V5.34305Z"
      fill="#3E7DC0"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20.0003 9.27252H4.00034V8.27252H20.0003V9.27252Z"
      fill="#3E7DC0"
    />
    <rect x="1.5" y="14.0002" width="21" height="10" rx="2" fill="#3E7DC0" />
    <path
      d="M6.30469 22.0074H4.73828V18.9839C4.73828 18.6168 4.74609 18.2808 4.76172 17.9761C4.66536 18.0933 4.54557 18.2157 4.40234 18.3433L3.75391 18.8785L2.95312 17.8941L4.91406 16.2964H6.30469V22.0074Z"
      fill="#F8F8F8"
    />
    <path
      d="M8.12891 22.0074L10.0898 17.5816H7.61719V16.3043H11.7383V17.2144L9.72656 22.0074H8.12891Z"
      fill="#F8F8F8"
    />
    <path
      d="M12.8164 22.0074L14.7773 17.5816H12.3047V16.3043H16.4258V17.2144L14.4141 22.0074H12.8164Z"
      fill="#F8F8F8"
    />
    <path
      d="M20.3672 22.0074H18.8008V18.9839C18.8008 18.6168 18.8086 18.2808 18.8242 17.9761C18.7279 18.0933 18.6081 18.2157 18.4648 18.3433L17.8164 18.8785L17.0156 17.8941L18.9766 16.2964H20.3672V22.0074Z"
      fill="#F8F8F8"
    />
    <defs>
      <linearGradient
        id="paint0_linear_939_1101"
        x1="12.6667"
        y1="3.34244"
        x2="12.6667"
        y2="11.9145"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#11AAE2" stop-opacity="0.49" />
        <stop offset="1" stop-color="white" stop-opacity="0" />
      </linearGradient>
    </defs>
  </g>
</template>
